import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
})
export class SkeletonComponent implements OnInit {
  @Input() active: boolean = true;
  @Input() avatar: boolean = true;
  constructor() {}

  ngOnInit(): void {}
}
